import store from "@/store";
import { decimalToHexColor } from "./utils/utilsColor";

function calcUserName(user) {
  if(!user) return ''
  let friend = store.getters.friends_map[user.user_id]
  //  展示优先级：备注>房间内昵称>用户名称
  return friend?.remarks || user.remarks || user.room_nickname || user.group_nickname || user.nickname || user.user_nickname
}
function calcUserRoleColor(role_ids, default_color = 'var(--opacity-6)') {
  //输入一个id列表， 返回一个16进制颜色字符串
  if(!role_ids) return ''
  let res = []
  role_ids.forEach(role_id => {
    let tar = store.getters.cur_roles_list.find(item => item.id == role_id)
    if(tar && tar.hoist) {
      res.push(tar)
    }
  })
  res.sort((a,b) => {
    if(a.position == b.position) return 0
    else return a.position < b.position ? -1 : 1
  })
  if(res.length > 0) {
    if(res[0].color_list && res[0].color_list.length == 2) {
      return res[0].color_list.map(item => decimalToHexColor(item))
    }
    return decimalToHexColor(res[0].color, default_color)
  } else return default_color
}
export {
  calcUserName,
  calcUserRoleColor,
};